import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './FirstConversation.module.less';
import { aigcGetReplys, aigcShowDialog } from '../../../actions/aigc';

let questionList = [
  { id: 1, question: '帮我推荐几个压缩软件' },
  { id: 2, question: '我想看中国新说唱，推荐一个软件' },
  { id: 3, question: '请介绍一下原神' },
  { id: 4, question: '请帮我升级一下QQ' },
];

export default memo(() => {
  const dispatch = useDispatch();

  const handleQuestion = info => {
    dispatch(aigcGetReplys({ userText: info }));
  };

  return (
    <div className={styles.first_conversation}>
      <div className="conversation_title">我是小乐，您的智能助手</div>
      <div className="conversation_desc">联想应用商店推出AI应用搜索，快来试试您身边的应用专家</div>
      <div className="question_list">
        <div className="question_desc">请准确描述您的需求或问题，例如：</div>
        {questionList.map((item, index) => (
          <div key={index} className="question_item" onClick={() => handleQuestion(item.question)}>
            <span className="item_tag">#</span>
            <span className="item_question">{item.question}</span>
          </div>
        ))}
      </div>
    </div>
  );
});
